import { Component, ElementRef, OnInit, NgZone, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { } from 'googlemaps';
import { GoogleService } from '../../../service/googleService'
import { LocalStorageService } from 'src/app/utils/local-storage.service';

@Component({
  selector: 'app-google-auto-complete',
  templateUrl: './google-auto-complete.component.html',
  styleUrls: ['./google-auto-complete.component.scss']
})
export class GoogleAutoCompleteComponent implements OnInit {
  @Output() placeDetailsEvent = new EventEmitter();
  @Input() id: any;
  constructor(private localData: LocalStorageService, private mapsAPILoader: MapsAPILoader, private ngZone: NgZone, public googleService: GoogleService,) { }
  // placeDetails: any = {};

  ngOnInit() {
  }
  @ViewChild("searchDeliveryPlace", { static: false }) public searchDeliveryPlaceElementRef: ElementRef;
  ngAfterViewInit() {

    this.mapsAPILoader.load().then(() => {
      var autocompleteDeliveryPlace = new google.maps.places.Autocomplete(this.searchDeliveryPlaceElementRef.nativeElement);
      autocompleteDeliveryPlace.addListener("place_changed", () => {
        this.ngZone.run(async () => {
          let place: google.maps.places.PlaceResult = autocompleteDeliveryPlace.getPlace();
          var placeDetails = await this.googleService.googleAddressLoad(place);
          this.placeDetailsEvent.emit(placeDetails);
        })
      })
    })
  }

}
